<ng-container *ngIf="vm$ | async as vm">
  <div class="tdt-main-container" [ngClass]="{'is-loading': vm.loading}">
    <div class="tdt-header-container">
      <div class="tdt-header-info">
        <a *ngIf="userRoleWorkspacePriority >= 30" class="tdt-back" [routerLink]="'/team-dynamics-reporting'">
          <i class="bi bi-chevron-left"></i>
          <span>{{ 'td_team_report_back' | translate }}</span>
        </a>

        <h1 class="tdt-team-name">
          <span>{{ 'wo_team_dynamic_title' | translate }}</span>
          <span class="tdt-team-name-sep">|</span>
          <a class="tdt-team-name-link" [routerLink]="['/team', teamUuid]">{{ vm.header?.teamName }}</a>
        </h1>

        <div class="tdt-people">
          <div class="tdt-leader" *ngIf="vm.header?.leader as leader">
            <span class="tdt-crown"></span>
            <span class="tdt-avatar tdt-avatar-leader">
              <img *ngIf="leader.avatarUrl" [src]="leader.avatarUrl" [alt]="leader.name">
              <span class="tdt-avatar-initials" *ngIf="!leader.avatarUrl"
                    [ngStyle]="{'background-color': leader.initialsColor}">{{ leader.initials }}</span>
            </span>
            <span class="tdt-leader-name">{{ leader.name }}</span>
            <span class="tdt-leader-role">{{ leader.roleLabel }}</span>
          </div>

          <span class="tdt-dot" *ngIf="vm.header?.leader && vm.header?.membersCount">·</span>

          <div class="tdt-members" *ngIf="vm.header?.membersCount">
            <span class="tdt-avatar-stack">
              <span class="tdt-avatar tdt-avatar-stacked" *ngFor="let member of vm.visibleMembers">
                <img *ngIf="member.avatarUrl" [src]="member.avatarUrl" [alt]="member.name">
                <span class="tdt-avatar-initials" *ngIf="!member.avatarUrl"
                      [ngStyle]="{'background-color': member.initialsColor}">{{ member.initials }}</span>
              </span>
              <span class="tdt-avatar tdt-avatar-stacked tdt-avatar-more" *ngIf="vm.hiddenMembers">
                <span class="tdt-avatar-initials">+{{ vm.hiddenMembers }}</span>
              </span>
            </span>
            <span class="tdt-members-label">
              {{ 'td_team_report_members' | translate : {count: vm.header?.membersCount} }}
            </span>
          </div>
        </div>
      </div>

      <div class="tdt-header-tools">
        <p-dropdown #periodDropdown
                    [options]="periodOptions"
                    [(ngModel)]="period"
                    optionLabel="label" optionValue="value"
                    scrollHeight="auto"
                    dropdownIcon="bi bi-caret-down-fill"
                    styleClass="wo-dropdown"
                    panelStyleClass="wo-dropdown-panel td-period-panel"
                    (onChange)="onPeriodChange($event)"
                    (onHide)="showPeriodCalendar = false">
          <ng-template pTemplate="selectedItem">
            <span>{{ periodLabel }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="td-period-option" *ngIf="option.value === 'all'">
              {{ option.label }}
            </div>
            <div class="td-period-option" *ngIf="option.value === 'custom'"
                 (mouseenter)="showPeriodCalendar = true"
                 (mouseleave)="showPeriodCalendar = false">
              {{ option.label }}
              <i class="bi bi-caret-down-fill td-period-caret" [ngClass]="{'open': showPeriodCalendar}"></i>
              <div class="calendar-container" *ngIf="showPeriodCalendar" (click)="$event.stopPropagation()">
                <p-calendar selectionMode="range" [(ngModel)]="periodRangeDates"
                            [ngModelOptions]="{standalone: true}" [inline]="true"></p-calendar>
                <div class="calendar-footer-container">
                  <span (click)="clearPeriodRange()">{{ 'clear_button' | translate }}</span>
                  <span (click)="cancelPeriodRange()" style="margin-left:auto">{{ 'cancel_button' | translate }}</span>
                  <span (click)="submitPeriodRange()">{{ 'ok_button' | translate }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div class="spinner-border text-primary tdt-spinner" role="status" *ngIf="vm.loading"></div>

    <div class="tdt-body-container" *ngIf="!vm.loading">
      <app-team-insights [insights]="vm.insights"></app-team-insights>

      <div class="tdt-cards-row">
        <app-team-health-score class="tdt-card-slot" [data]="vm.healthScore"></app-team-health-score>

        <app-team-pyramid-flip class="tdt-card-slot"
                               [categories]="vm.pyramidCategories"
                               [legend]="vm.pyramidLegend"
                               [teamScores]="vm.teamScores"
                               [workspaceScores]="vm.workspaceScores"
                               [scoreChips]="vm.scoreChips"
                               [activeChipUuid]="activeChipUuid"
                               [loadingScores]="vm.loadingScores"
                               (categorySelected)="onPyramidCategory($event)"
                               (chipSelected)="onScoreChip($event)">
        </app-team-pyramid-flip>
      </div>

      <app-team-indicators [rows]="vm.indicatorRows"
                           [openUuid]="vm.openIndicatorUuid"
                           [scores]="vm.indicatorScores"
                           [loadingScores]="vm.loadingIndicator"
                           [statements]="vm.indicatorStatements"
                           [loadingStatements]="vm.loadingIndicator || vm.loadingStatements"
                           [statementResponses]="vm.statementResponses"
                           [periodStartDate]="requestPayload.startDate"
                           [periodEndDate]="requestPayload.endDate"
                           [distribution]="vm.indicatorDistribution"
                           [teamsTotal]="vm.indicatorTeamsTotal"
                           [showDistribution]="vm.teamVisibility"
                           (opened)="onIndicatorOpened($event)"
                           (closed)="onIndicatorClosed()"
                           (statementFiltersChanged)="onStatementFilters($event)"
                           (statementOpened)="onStatementOpened($event)">
      </app-team-indicators>
    </div>
  </div>
</ng-container>
